import axios from 'axios';
import { createSignedGetRequest } from './createSignedRequestsHelpers';

export const fetchPrivateProjectBankImageThumbnail = async ({
  projectId,
  fileId,
  cancelTokenSource,
  blobUrl,
  blob,
}) => {
  if (!cancelTokenSource) cancelTokenSource = axios.CancelToken.source();

  const apiPath = `project-bank/private/project/${projectId}/file/${fileId}/thumbnail-signed-url`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  const signedDownloadUrl = response.data.downloadUrl;

  try {
    if (blobUrl) {
      const blobResponse = await axios.get(signedDownloadUrl, {
        responseType: 'blob',
        cancelToken: cancelTokenSource.token, // Set the cancellation token
      });

      const blob = new Blob([blobResponse.data]);
      const url = URL.createObjectURL(blob);
      return url;
    }

    if (blob) {
      const blobResponse = await axios.get(signedDownloadUrl, {
        responseType: 'blob',
        cancelToken: cancelTokenSource.token, // Set the cancellation token
      });

      return new Blob([blobResponse.data]);
    }

    return signedDownloadUrl;
  } catch (error) {
    console.log('error fetching file:', error);
  }
};
